import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'Douleutaras/redux/store';
import { JSONApiDataObject, ReduxEntity, UserV2 } from 'Douleutaras/types';
import { makeRequest } from 'Douleutaras/services/apiClient';
import normalize from 'json-api-normalizer';

const usersAdapter = createEntityAdapter<JSONApiDataObject<UserV2>>({
  selectId: cat => cat.id
});

const API_USER_V3 = 'api/public/v3/users/';

export const fetchUser = createAsyncThunk(
  'user/get',
  async (id: number, api) => {
    const endpoint = `${API_USER_V3}${id}/`;
    const response = await makeRequest(
      endpoint,
      { method: 'GET' }
    )(api);

    return normalize(response.data, { endpoint });
  }
);

export const usersSlice = createSlice({
  name: 'users',
  initialState: usersAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<JSONApiDataObject<UserV2>>),
  reducers: {
    usersAdded: (state, action) => {
      usersAdapter.setMany(state, action.payload);
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchUser.fulfilled, (state, action) => {
      return action.payload;
    });
  }
});

export const { usersAdded } = usersSlice.actions;
export const usersSelector = usersAdapter.getSelectors((state: RootState) => state.users);
